/*
window._trackJs = { 
  token: '39777333c364485e911097c1c7a4c94b',
  enabled: !(window.location.host.indexOf('localhost') >= 0)
}

export var log = console

if( window ){
	var trackjs = require('trackjs')
	// Log
	log = _.assign({}, trackjs.console, {
	    track: trackjs.track  
	})
}
*/
export var log = console
log.debug = function(message){
	if( window.VELOX_DEBUG ){
		console.log(message)
	}
}